export const COMMON_FIELD_TYPES = {
    TEXT_FIELD: "text",
    EMAIL_FIELD: "email",
    PASSWORD_FIELD: "password",
    CONFIRM_PASSWORD: 'confirmPassword',
    PHONE: "phone",
    REQUIRED_FIELD: "requiredField",
    BOOLEAN_FIELD: 'booleanField',
    NUMBER_FIELD: "number",
    URL: "url",
    DROPDOWN: "dropdown",
    DATE_PICKER: "datePicker",
    TIME_PICKER: "timePicker",
    ID_NUMBER: 'idNumber',
    EMAIL: 'email',
    EMAIL_OR_PHONE: 'emailOrPhone',
    USERNAME: 'username',
    COUNTRY: 'country',	
    STATE: 'state',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    MULTIPLE_DROPDOWN: 'multipleDropdown',
    DJ_NAME: 'djName',
    EXISTING_EMAIL: 'existingEmail',
    CHECKBOX: 'checkbox',
    OPTIONAL_FIELD: 'optionalField',
    ONE_OF_TWO_REQUIRED: "oneOfTwoRequired", 
    RADIO_GROUP: "radioGroup", 
    CHECKBOX_GROUP: "checkboxGroup", 
  
};